import { normalizarStatus } from "../constants/statusPedido";
import { calcPagamento } from "./pagamento";
import { ehVendaOnline, repassePrevisto } from "./vendaOnline";

export const moedaPedido = valor => (Number(valor) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export function dataPedido(valor) {
  if (!valor) return null;
  if (typeof valor.toDate === "function") return valor.toDate();
  if (valor.seconds != null) return new Date(valor.seconds * 1000);
  if (typeof valor === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
    const [d, m, a] = valor.split("/");
    return new Date(Number(a), Number(m) - 1, Number(d));
  }
  const d = new Date(typeof valor === "string" && /^\d{4}-\d{2}-\d{2}$/.test(valor) ? `${valor}T12:00:00` : valor);
  return Number.isNaN(d.getTime()) ? null : d;
}
export const canalPedido = p => p.venda_online?.canal || p.origem || "balcao";
export const nomeCanalPedido = p => p.venda_online?.canal_nome || ({ balcao: "Balcão", site: "Site", orcamento: "Orçamento" }[canalPedido(p)]) || canalPedido(p);
export function financeiroPedido(p) {
  const pg = calcPagamento(p);
  const online = ehVendaOnline(p.venda_online);
  const pendente = normalizarStatus(p.status) !== "cancelado" && pg.saldo > 0.005 && !pg.quitado;
  return { ...pg, online, pendente, etiqueta: !pendente ? (normalizarStatus(p.status) === "cancelado" ? "Cancelado" : "Quitado") : online ? "Aguardando repasse" : pg.recebido > 0 ? "Parcial" : "A receber" };
}
const normalizar = s => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
export function filtrarPedidos(pedidos, { busca = "", status = "", canal = "", pagamento = "", periodo = "" } = {}, agora = new Date()) {
  const termo = normalizar(busca.trim());
  const limite = new Date(agora); limite.setHours(0, 0, 0, 0); limite.setDate(limite.getDate() - Math.max(0, Number(periodo) - 1));
  return pedidos.filter(p => {
    if (status && normalizarStatus(p.status) !== status) return false;
    if (canal && canalPedido(p) !== canal) return false;
    const pg = financeiroPedido(p);
    if (pagamento === "pendente" && !pg.pendente) return false;
    if (pagamento === "repasse" && !(pg.pendente && pg.online)) return false;
    if (pagamento === "quitado" && (!pg.quitado || normalizarStatus(p.status) === "cancelado")) return false;
    const data = dataPedido(p.created_at || p.data);
    if (periodo && (!data || data < limite)) return false;
    return !termo || normalizar([p.cliente, p.produto, p.id, p.venda_online?.numero_loja, nomeCanalPedido(p), ...(p.itens || []).map(i => i.nome)].join(" ")).includes(termo);
  }).sort((a, b) => (dataPedido(b.created_at || b.data)?.getTime() || 0) - (dataPedido(a.created_at || a.data)?.getTime() || 0));
}
export function resumoPedidos(pedidos) {
  return pedidos.reduce((r, p) => {
    const s = normalizarStatus(p.status), pg = financeiroPedido(p);
    if (["conferindo_pagamento", "aguardando_impressao", "imprimindo"].includes(s)) r.producao++;
    if (["concluido", "pronto_entrega"].includes(s)) r.entrega++;
    if (pg.pendente) { r.pendentes++; r.receber += pg.online ? repassePrevisto(p) : pg.saldo; }
    if (s !== "cancelado") r.vendas += pg.total;
    return r;
  }, { producao: 0, entrega: 0, pendentes: 0, receber: 0, vendas: 0 });
}
